export const ENVIRONMENTS = {
  development: 'development',
  staging: 'staging',
  production: 'production',
};

export const GTM_ID = 'GTM-M25JWD9';
